import { useMemo } from "react";
import type { TFunction } from "i18next";

const PURCHASE_FINANCING_PRODUCT_TYPE = "PURCHASE_FINANCING" as const;

type UseShariaAuditOrderDetailsLabelsArgs = {
  t: TFunction;
  language: string;
};

export function useShariaAuditOrderDetailsLabels({
  t,
  language,
}: UseShariaAuditOrderDetailsLabelsArgs) {
  return useMemo(() => {
    const isArabicLocale = language.startsWith("ar");
    const effectiveAprLabel = isArabicLocale
      ? t("sharia_audit.order.effective_apr")
      : t("order.effective_apr");

    function productTypeLabel(productType: string): string {
      const useCompliancePurchaseFinancingLabel =
        isArabicLocale && productType === PURCHASE_FINANCING_PRODUCT_TYPE;
      return useCompliancePurchaseFinancingLabel
        ? t("sharia_audit.product_type.PURCHASE_FINANCING")
        : t(`product_type.${productType}`);
    }

    return { effectiveAprLabel, productTypeLabel };
  }, [t, language]);
}
